const STAGE = 520;
const DEFAULT_SIZE = 1144; // STAGE * 2.2

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function containRect(iw, ih, size) {
  const scale = Math.min(size / iw, size / ih);
  const w = iw * scale;
  const h = ih * scale;
  return { dx: (size - w) / 2, dy: (size - h) / 2, dw: w, dh: h };
}

// Renders the mockup to a PNG dataURL. Design coords are in STAGE space.
export async function renderMockup({ garmentSrc, color, designs, outSize = DEFAULT_SIZE }) {
  const SIZE = outSize;
  const SCALE = SIZE / STAGE;
  const canvas = document.createElement("canvas");
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(0, 0, SIZE, SIZE);

  const garment = await loadImage(garmentSrc);
  const r = containRect(garment.naturalWidth, garment.naturalHeight, SIZE);

  const gc = document.createElement("canvas");
  gc.width = SIZE;
  gc.height = SIZE;
  const gctx = gc.getContext("2d");
  gctx.drawImage(garment, r.dx, r.dy, r.dw, r.dh);
  gctx.globalCompositeOperation = "multiply";
  gctx.fillStyle = color;
  gctx.fillRect(0, 0, SIZE, SIZE);
  gctx.globalCompositeOperation = "destination-in";
  gctx.drawImage(garment, r.dx, r.dy, r.dw, r.dh);
  gctx.globalCompositeOperation = "source-over";

  ctx.drawImage(gc, 0, 0);

  if (designs && designs.length) {
    for (const design of designs) {
      if (!design || !design.imgSrc) continue;
      const d = await loadImage(design.imgSrc);
      const cx = (design.x + design.w / 2) * SCALE;
      const cy = (design.y + design.h / 2) * SCALE;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(((design.rotation || 0) * Math.PI) / 180);
      ctx.drawImage(d, (-design.w / 2) * SCALE, (-design.h / 2) * SCALE, design.w * SCALE, design.h * SCALE);
      ctx.restore();
    }
  }

  return canvas.toDataURL("image/png");
}

export async function downloadMockup(opts, filename = "mockup.png") {
  const dataUrl = await renderMockup(opts);
  triggerDownload(dataUrl, filename);
  return dataUrl;
}

export function triggerDownload(dataUrl, filename) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export async function urlToDataURL(url) {
  const res = await fetch(url, { credentials: "include" });
  const blob = await res.blob();
  return await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export async function watermarkDataURL(dataUrl, maxSize = 820) {
  const img = await loadImage(dataUrl);
  const scale = Math.min(1, maxSize / Math.max(img.naturalWidth, img.naturalHeight));
  const w = Math.round(img.naturalWidth * scale);
  const h = Math.round(img.naturalHeight * scale);
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);
  ctx.save();
  ctx.translate(w / 2, h / 2);
  ctx.rotate((-28 * Math.PI) / 180);
  ctx.translate(-w / 2, -h / 2);
  ctx.font = `bold ${Math.max(20, Math.round(w / 11))}px sans-serif`;
  ctx.fillStyle = "rgba(15,15,15,0.26)";
  ctx.textBaseline = "middle";
  const stepY = Math.max(48, Math.round(w / 6));
  const stepX = Math.max(190, Math.round(w * 0.82));
  let row = 0;
  for (let y = -h; y < h * 2; y += stepY) {
    const off = (row % 2) * Math.round(w / 3);
    for (let x = -w; x < w * 2; x += stepX) ctx.fillText("VISTA PREVIA", x + off, y);
    row++;
  }
  ctx.restore();
  return canvas.toDataURL("image/png");
}

export { STAGE };
